<template>
  <div v-if="content.data">
 
    <Introrew />
    <Future />
    <Manifesto  v-if="content.data.manifesto.visible" />
    <SliderDishes v-if="content.data.dishes.visible" />
    <Authors v-if="content.data.authors.visible" />
    
    <HowToGetBook v-if="content.data.how.visible" />
    <Protests v-if="content.data.protests.visible" />
    <Talks />
   
 
  </div>
</template>

<script>
import Introrew from "./home/Introrew.vue";
import Future from "./home/Future.vue";
import Manifesto from "./home/Manifesto.vue";
import Authors from "./home/Authors.vue";
import SliderDishes from "./home/SliderDishes.vue";
import HowToGetBook from "./home/HowToGetBook.vue";
import Protests from "./home/Protests.vue";
import Talks from "./home/Talks.vue";


export default {
  name: "MainPage",
  inject: ["content"],
  data() {
    return {
      title: "home page",
    };
  },
  components: {
    Introrew,
    Future,
    Manifesto,
    Authors,
    SliderDishes,
    HowToGetBook,
    Protests,
    Talks,
  },
};
</script>
